import {Component, OnInit} from '@angular/core';
import {QuestionFlowSessionQuery} from '../../questions/state/question-flow-session.query';
import {GlobalQuestionService} from '../../services/global-question.service';
import {environment} from 'src/environments/environment';
import { AnimationOptions } from 'ngx-lottie';
import { NavigationEnd, Router } from '@angular/router';
import { RouterLinks } from '../../constants';

@Component({
    selector: 'app-disclaimer',
    templateUrl: './disclaimer.component.html',
    styleUrls: ['./disclaimer.component.scss'],
    standalone: false
})
export class DisclaimerComponent implements OnInit {
  sessionDetails = this.questionFlowSessionQuery.session;
  categories: any;
  web = environment.cssURL;
  options: AnimationOptions = {
    path: 'assets/evi-icon.json',
  };
  showSesssion = false;
  constructor(private questionFlowSessionQuery: QuestionFlowSessionQuery,
    public questionService: GlobalQuestionService,
    public router: Router,
    ) {
    this.router.events.subscribe((ev: any) => {
      if (ev instanceof NavigationEnd) {
        
        if(ev.url.includes(RouterLinks.QuestionFlow) 
          || ev.url.includes(RouterLinks.QuotePickCover)
          || ev.url.includes(RouterLinks.QuoteConfirmCover)
          || ev.url.includes(RouterLinks.QuoteCustomizeCover)
          || ev.url.includes(RouterLinks.QuotePayCover)
          || ev.url.includes(RouterLinks.QuoteUWPage)
        ){
          this.showSesssion = true;
        }
        else{
          this.showSesssion = false;
        }
      }
    })
  }

  ngOnInit(): void {
   
  }

}
